module.exports = __webpack_public_path__ + "static/media/1.8dfb4e44.png";